import React from "react";
import { Link } from "react-router-dom";
import BrandNav from "../components/BrandNav";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div data-testid="checkout-cancel-page">
      <BrandNav />
      <main className="ftg-shell ftg-page">
        <div className="ftg-verify">
          <div className="ftg-verify__card">
            <XCircle size={40} style={{ color: "#a89a85" }} />
            <h1 className="ftg-verify__title" data-testid="checkout-cancel-title">Checkout cancelled</h1>
            <p className="ftg-verify__body">
              No charge was made. Whenever you&apos;re ready, hop back to the pricing section — your progress is safe.
            </p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
              <Link to="/#pricing" className="ftg-btn ftg-btn--secondary" data-testid="checkout-cancel-back">
                Back to pricing
              </Link>
              <Link to="/dashboard" className="ftg-btn ftg-btn--ghost">Open dashboard</Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
